export default function AccordionListItemLayout() {
  const listItems = document.querySelectorAll('.accordion-content__wrapper ul li');

  listItems.forEach((li) => {
    // Select the first image inside the li
    const img = li.querySelector('img');
    const childNodes = Array.from(li.childNodes);

    // If image exists and there are additional child nodes, wrap them in a span
    if (img && childNodes.length > 2) {
      const span = document.createElement('span');

      // Append/Move all non-image nodes to the span
      childNodes.forEach((node) => {
        if (node !== img) {
          span.appendChild(node);
        }
      });

      // Append the span back to the li
      li.appendChild(span);
    }
  });
}
